import { cn } from "../lib/utils";
import { DEFAULT_BANK_ICON_ID, resolveBankIcon } from "../assets/banks/bankIcons";

const SIZE_CLASSES = {
  sm: "h-8 w-8 min-h-8 min-w-8",
  md: "h-10 w-10 min-h-10 min-w-10",
  lg: "h-12 w-12 min-h-12 min-w-12",
};

function getTextSize(text) {
  if (!text) return 18;
  if (text.length <= 1) return 24;
  if (text.length <= 2) return 18;
  if (text.length <= 3) return 14;
  return 11;
}

function DefaultBankMark({ color }) {
  return (
    <g fill={color}>
      <path d="M24 10 10 18v4h28v-4L24 10Z" />
      <path d="M14 24h4v10h-4V24Zm8 0h4v10h-4V24Zm8 0h4v10h-4V24Z" />
      <path d="M11 36h26v4H11v-4Z" />
    </g>
  );
}

export function BankIcon({ iconId, bankName, size = "md", className, title }) {
  const icon = resolveBankIcon(iconId, bankName);
  const isDefault = icon.id === DEFAULT_BANK_ICON_ID;
  const textSize = getTextSize(icon.text);

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-border bg-muted align-middle",
        SIZE_CLASSES[size] || SIZE_CLASSES.md,
        className
      )}
      role="img"
      aria-label={title || icon.label}
      title={title || icon.label}
    >
      <svg viewBox="0 0 48 48" preserveAspectRatio="xMidYMid meet" className="block h-full w-full" aria-hidden="true">
        <circle cx="24" cy="24" r="23.5" fill={icon.bg} />
        {isDefault ? (
          <DefaultBankMark color={icon.fg} />
        ) : (
          <>
            <circle cx="24" cy="24" r="20" fill="none" stroke="rgba(255,255,255,0.22)" strokeWidth="2" />
            <text
              x="24"
              y="24"
              textAnchor="middle"
              dominantBaseline="middle"
              dy="0.08em"
              fill={icon.fg}
              fontFamily="Arial, Helvetica, sans-serif"
              fontSize={textSize}
              fontWeight="800"
              letterSpacing="0"
            >
              {icon.text}
            </text>
          </>
        )}
      </svg>
    </span>
  );
}
